// Returns keys for VIZBI talks/videos, sorted in canonical VIZBI order (Keynotes, DNA, RNA, ...)

const log = (msg) => process.env.VUE_APP_DEV && console.log(`useVizbiOrder: ${msg}`); // eslint-disable-line
const tagOrder = [
  "Keynote",
  "DNA",
  "RNA",
  "Proteins",
  "Cells",
  "Tissues",
  "Ecosystems",
  "Closing",
  "Showcase"
];

const getTagRank = (tag) => {
  const index = tagOrder.findIndex((t) => t.toLowerCase() === tag?.trim().toLowerCase());
  return index === -1 ? tagOrder.length : index;
};

export function useVizbiOrder(talks) {
  log(`talks = ${JSON.stringify(talks, null, 2)}`);
  return Object.keys(talks).sort((a, b) => {
    const rankA = getTagRank(talks[a].tag);
    const rankB = getTagRank(talks[b].tag);
    return rankA - rankB;
  });
}
